import { I as t } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as o, createElementVNode as i } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconPower",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(t).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function m(a, r, l, f, p, e) {
  return d(), n("svg", {
    "aria-label": l.ariaLabel,
    class: o([e.iconSizeClass, "d-icon d-icon--power"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Power",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...r[0] || (r[0] = [
    i("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.168 2.966a.5.5 0 0 1 0 .708 4 4 0 1 0 5.658 0 .5.5 0 1 1 .708-.707 5 5 0 1 1-7.073 0 .5.5 0 0 1 .708 0Z",
      "clip-rule": "evenodd"
    }, null, -1),
    i("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6 .5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V1A.5.5 0 0 1 6 .5Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, u);
}
const w = /* @__PURE__ */ s(c, [["render", m]]);
export {
  w as default
};
//# sourceMappingURL=power.js.map
